import Handimg from "../Hand.svg"
const Build = () => {
    return (
   
  <img src={Handimg} />


    )
  }
  export default Build;